const sendDeliveryReceipt = async (_userDispatchId: string): Promise<void> => {};

export { sendDeliveryReceipt };
